import api from '@api/Api';

export default {

    getTemplate(id) {
        return api().get(`/templates/${id}`);
    },

    updateTemplate(id, params) {
        return api().put(`/templates/${id}`, params);
    },

    updateTemplateName(id, name) {
        return api().put(`/templates/${id}/name`, { name: name });
    },

    makeDefaultTemplate(id) {
        return api().put(`/templates/${id}/default`);
    },

    duplicateTemplate(id, params) {
        return api().post(`/templates/${id}/duplicate`, params);
    },

    deleteTemplate(id) {
        return api().delete(`/templates/${id}`);
    },

    getBuilder(id) {
        return api().get(`/templates/${id}/builder`);
    },

    testTemplate(id, params) {
        return api().post(`/templates/${id}/test`, params);
    },

}
